/**
 * @file src/pages/invoice-management-hub/components/FloatingActionButton.jsx
 * @description Bottom-right circular FAB that expands to show
 * "Create Invoice" and "Upload Invoice" actions.
 *
 * Self-contained — owns its own open/closed state. Parent only needs to
 * pass an onCreateInvoice callback.
 */

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "components/ui/Button";
import Icon from "components/AppIcon";

const FloatingActionButton = ({ onCreateInvoice }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="absolute bottom-16 right-0 space-y-3"
          >
            <Button
              variant="default"
              size="md"
              iconName="Upload"
              className="shadow-lg hover:shadow-xl w-full justify-start"
            >
              Upload Invoice
            </Button>
            <Button
              variant="default"
              size="md"
              iconName="Plus"
              className="shadow-lg hover:shadow-xl w-full justify-start"
              onClick={onCreateInvoice}
            >
              Create Invoice
            </Button>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center"
      >
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <Icon name="Plus" size={24} />
        </motion.div>
      </motion.button>
    </div>
  );
};

export default FloatingActionButton;